import React, { useContext, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Checkbox } from 'ui-components/components/checkbox';

import { SplitOnCustomQty } from '../constants/auto-split-options';
import { ProductDetailsContext } from '../context';
import { messages } from '../messages';
import style from '../style.module.less';

export const ProductDetailsModalFooter = () => {
  const {
    userHasPermission,
    applyToOpenFulfillmentPlans,
    setApplyToOpenFulfillmentPlans,
    closeModal,
    onSaveClicked,
    isSaveInPlaceRequired,
    isSaveInPlaceLoading,
    productAliases,
    autoSplitOption,
    autoSplitCustomQuantity,
  } = useContext(ProductDetailsContext);
  const onSave = useCallback(() => {
    onSaveClicked();
  }, [onSaveClicked]);

  const hasIncompleteAliases = productAliases.some((alias) => alias.aliasSKU?.length === 0);

  const hasAutoSplitCustomQtyLessThanOne =
    autoSplitOption === SplitOnCustomQty && (!autoSplitCustomQuantity || autoSplitCustomQuantity <= 0);

  return (
    <>
      <div className={style['footer-buttons']}>
        <Checkbox
          checked={applyToOpenFulfillmentPlans}
          className={style['apply-to-open-orders-checkbox']}
          disabled={!userHasPermission}
          label={<FormattedMessage {...messages.applyToOpenOrders} />}
          onChange={setApplyToOpenFulfillmentPlans}
        />
        <Button onClick={closeModal} theme='tertiary'>
          <FormattedMessage {...messages.close} />
        </Button>
        <Button
          disabled={isSaveInPlaceLoading || isSaveInPlaceRequired || hasIncompleteAliases || hasAutoSplitCustomQtyLessThanOne}
          onClick={onSave}
          theme='primary'
        >
          <FormattedMessage {...messages.save} />
        </Button>
      </div>
    </>
  );
};
